import { NewCheckbox, Checkbox } from '@carta/ink';
import * as React from 'react';
export default {
  NewCheckbox,
  Checkbox,
  React
};